module.exports = __webpack_public_path__ + "img/superman_and_2_badmans.e4286dd7.jpg";